angular.module('picmonicng').directive('commentFeed', [
  function () {
    return {
      restrict: 'E',
      scope: {
        slug: '@',
      },
      controller: [
        '$rootScope',
        '$scope',
        'CommentsResource',
        'UserService',
        function ($rootScope, $scope, CommentsResource, UserService) {
          $scope.loading = true;
          $scope.UserService = UserService;
          $scope.comments = CommentsResource.query({ slug: $scope.slug });
          $scope.comments.$promise.then(function (data) {
            $scope.loading = false;
            $scope.upload_url = $rootScope.upload_url;
          });
        },
      ],
      templateUrl: '/templates/directives/comment-feed.html',
    };
  },
]);
